import { render, staticRenderFns } from "./TeachIndex.vue?vue&type=template&id=b0f9abce&scoped=true"
import script from "./TeachIndex.vue?vue&type=script&lang=js"
export * from "./TeachIndex.vue?vue&type=script&lang=js"
import style0 from "./TeachIndex.vue?vue&type=style&index=0&id=b0f9abce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f9abce",
  null
  
)

export default component.exports